import {ConfigText} from 'components/common/ConfigText'
import {Image} from 'components/common/Image'
import {Button} from 'components/system/Button'
import {useExp1ProductMap} from 'hooks/useExp1ProductMap'
import {ReactComponent as DownIcon} from 'icons/down.svg'
import {ReactComponent as UpIcon} from 'icons/up.svg'
import {useCartState, useOrderDetailsMutators} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {formatMoney} from 'utils/formatMoney'
import {getDiscountDetails} from 'utils/getDiscountDetails'
import {getTotalAmount} from 'utils/getTotalAmount'
import {CartItem} from './CartItem'
import {Discount} from './Discount'

export const CartItems = () => {
  const order = OrderProvider.useOrder()
  const cartState = useCartState()
  const {toggleCartState} = useOrderDetailsMutators()
  const exp1ProductMap = useExp1ProductMap(order)

  const toggle = useCallback(() => {
    toggleCartState()
  }, [toggleCartState])

  const discountDetails = getDiscountDetails(order)

  if (cartState === 'closed') {
    return (
      <div className="flex flex-col gap-4 bg-gray-4 p-4 rounded-lg">
        <div className="flex justify-between">
          <div className="font-bold text-lg">Order details</div>
          <div className="flex justify-end font-bold">
            {formatMoney(order.pricing?.retail || 0, order.pricing?.currency)}
          </div>
        </div>
        <div className="flex justify-between">
          <div className="flex ml-1">
            {order.bookings.map((booking) => {
              return (
                <Image
                  key={booking.uuid}
                  src={booking.option.coverImageUrl}
                  title={booking.option.title}
                  className="!min-w-6 !w-6 !h-6 !rounded-md -ml-1"
                />
              )
            })}
          </div>
          <Button.Simple className="flex items-center gap-0.5" onClick={toggle}>
            <div className="text-sm font-medium">Show more</div>
            <DownIcon />
          </Button.Simple>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center bg-white rounded-t-lg p-4 border border-solid border-gray-4">
        <div className="font-bold text-lg">Order details</div>
        <Button.Simple className="flex items-center gap-0.5" onClick={toggle}>
          <div className="text-sm font-medium">Hide details</div>
          <UpIcon />
        </Button.Simple>
      </div>

      {order.bookings.map((booking) => {
        const exp1Product = exp1ProductMap[booking.product.id]
        return <CartItem key={booking.uuid} booking={booking} exp1Product={exp1Product} />
      })}

      <Discount />

      <div className="flex flex-col bg-gray-4 p-4 rounded-b-lg gap-2">
        <div className="flex justify-between">
          <div>
            <ConfigText configKey="activitiesLabel" defaultText="Activities" /> x {order.bookings.length}
          </div>
          <div>{formatMoney(order.pricing?.original || 0, order.pricing?.currency)}</div>
        </div>

        {discountDetails && (
          <div className="flex justify-between">
            <div>{discountDetails.name}</div>
            <div>– {formatMoney(discountDetails.value, order.pricing?.currency)}</div>
          </div>
        )}

        <div className="flex justify-between">
          <div className="font-bold text-lg">Total</div>
          <div className="font-bold text-lg">{formatMoney(getTotalAmount(order), order.pricing?.currency)}</div>
        </div>
      </div>
    </div>
  )
}
